/**
 * 관리자에게 **새 오류·재발·새 신고** 건수를 알린다 (화면 오류 수집 3단계, 2026-09-14).
 *
 * 시범 규모라 메일·메신저 같은 외부 알림 없이 **화면 표시**로 한다(사용자 결정). 권한은 서버가 판정하고,
 * 관리자가 아니면 `enabled:false` 를 주므로 그때는 더 묻지 않는다. 로그 창을 열면(`markLogsSeen`) 곧바로 0.
 */
import { useEffect, useState } from 'react';
import { fetchUnseen, LOGS_SEEN_EVENT } from '../services/opsLog';

/** 묻는 주기. 알림이 몇 분 늦어도 되고, 폴링은 사용로그에 남지 않는다(`/sql-developer/logs` 는 SKIP). */
const POLL_MS = 5 * 60 * 1000;
const EMPTY = { total: 0, newGroups: 0, regressed: 0, feedback: 0 };

export default function useOpsLogAlerts(active) {
    const [alerts, setAlerts] = useState(EMPTY);

    useEffect(() => {
        if (!active) {
            setAlerts(EMPTY);
            return undefined;
        }
        let alive = true;
        let timer = null;
        const tick = async () => {
            try {
                const r = await fetchUnseen();
                if (!alive) return;
                // 관리자가 아니다 — 더 묻지 않는다
                if (!r || !r.enabled) { setAlerts(EMPTY); return; }
                setAlerts({
                    total: r.total || 0, newGroups: r.newGroups || 0, regressed: r.regressed || 0, feedback: r.feedback || 0,
                });
            } catch (_e) { /* 실패는 조용히 다음 주기에 — 알림이 화면을 막으면 안 된다 */ }
            if (alive) timer = setTimeout(tick, POLL_MS);
        };
        const onSeen = () => setAlerts(EMPTY);
        window.addEventListener(LOGS_SEEN_EVENT, onSeen);
        tick();
        return () => {
            alive = false;
            clearTimeout(timer);
            window.removeEventListener(LOGS_SEEN_EVENT, onSeen);
        };
    }, [active]);

    return alerts;
}
